module.exports = __webpack_public_path__ + "img/_natuerliche_Optik.b013e10a.svg";